






























































































































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import PickcookPopupService from '@/services/pickcook/pickcook-popup.service';
import { PickcookPopupDto } from '@/dto';
import { CONST_YN, Pagination, YN } from '@/common';
import toast from '../../../../../resources/assets/js/services/toast.js';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import PickcookFileUploadService from '../../../../services/shared/file-upload/pickcook-upload.service';
import { PICKCOOK_UPLOAD_TYPE } from '@/services/shared/file-upload/pickcook-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import { PickcookCodeManagementDto } from '@/services/init/dto';
import CommonCodeService from '@/services/pickcook/common-code.service';
import { PICKCOOK_POPUP, POPUP } from '@/services/shared';

@Component
export default class PickcookPopupList extends BaseComponent {
  private popupList: PickcookPopupDto[] = [];
  private popupSearchDto = new PickcookPopupDto();
  private popupCreateDto = new PickcookPopupDto();
  private pagination = new Pagination();
  private dataLoading = false;
  private popupTotalCount = null;
  private ynSelect: YN[] = [...CONST_YN];
  private popupTypeSelect: PickcookCodeManagementDto[] = [];
  private linkTypeSelect: PickcookCodeManagementDto[] = [];
  private codeManagementDto = new PickcookCodeManagementDto();
  private paginationCode = new Pagination();
  private popupImage: FileAttachmentDto[] = [];
  private startedDate: Date = null;
  private endedDate: Date = null;

  getLinkUrl(linkUrl: string) {
    if (linkUrl) {
      return linkUrl.includes('//') ? linkUrl : `//${linkUrl}`;
    }
  }

  getTypeCodes() {
    this.codeManagementDto.category = 'POPUP';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.popupTypeSelect = res.data.items;
    });

    this.codeManagementDto.category = 'LINK_TYPE';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.linkTypeSelect = res.data.items;
    });
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.popupSearchDto, this.pagination);
    }
    PickcookPopupService.findAll(
      this.popupSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.popupList = res.data.items;
        this.popupTotalCount = res.data.totalCount;
      }
    });
  }

  search() {
    this.findAll(true, true);
  }
  paginateSearch() {
    this.findAll(true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.popupSearchDto = new PickcookPopupDto();
      this.findAll();
    }
  }

  // create popup
  createPopup() {
    if (this.popupCreateDto.popupType === PICKCOOK_POPUP.EVENT) {
      if (this.popupImage.length > 0) {
        this.popupCreateDto.images = this.popupImage;
      } else {
        toast.error('이미지를 등록해주세요!');
        return;
      }
    }

    this.popupCreateDto.started = new Date(`${this.startedDate} 00:00:00`);
    this.popupCreateDto.ended = new Date(`${this.endedDate} 23:59:59`);

    PickcookPopupService.create(this.popupCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.clearOutPopupCreateDto();
        this.$bvModal.hide('add_popup');
        this.clearOut();
      }
    });
  }

  // upload popup image
  async upload(file: File) {
    if (file) {
      const attachments = await PickcookFileUploadService.upload(
        PICKCOOK_UPLOAD_TYPE.POPUP,
        [file],
      );
      this.popupImage = [];
      this.popupImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
    }
  }

  clearOutPopupCreateDto() {
    this.popupImage = [];
    this.popupCreateDto = new PickcookPopupDto();
    this.$bvModal.hide('add_popup');
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.popupSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getTypeCodes();
  }
}
